import { GKButton, GKClientDataGrid } from "components";
import { useFetchQuery } from "hooks/useQueries";
import { useState } from "react";
import { updatePortfolio } from "store/slices/portfolioSlice";
import { useAppDispatch, useAppSelector } from "store/store";
import { CLIENT_BANK_BY_ID } from "utils/apiRoutes";
import { extraColumnsField } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";
import BankAccountModal from "./BankAccountModal";

const BankInfoTab = ({ portfolioData }: any) => {
  const [openModal, setOpenModal] = useState(false);
  const [updateData, setUpdateData] = useState(null);

  const dispatch = useAppDispatch();

  const updatePortfolioLoading = useAppSelector(
    (state) => state?.portfolio?.loading,
  );

  const { data, isFetching, refetch } = useFetchQuery({
    key: [QueryKeys.PORTFOLIO_BANK_ACCOUNT],
    route: CLIENT_BANK_BY_ID(portfolioData?.client),
  });

  return (
    <>
      <GKClientDataGrid
        name="bankInfo"
        density="compact"
        headerComponent={
          <GKButton
            variant="outlined"
            size="small"
            color="dark"
            onClick={() => {
              setUpdateData(null);
              setOpenModal(true);
            }}
          >
            Add Bank Account
          </GKButton>
        }
        loading={updatePortfolioLoading || isFetching}
        rows={data?.data?.bankAccounts || []}
        onRowClick={(params) => {
          setOpenModal(true);
          setUpdateData(params.row);
        }}
        columns={[
          {
            ...extraColumnsField("Bank Account Name", "name", 150, 1),
          },
          { ...extraColumnsField("Bank Name", "bank", 150, 1) },
          {
            ...extraColumnsField("Bank Account Number", "accountNum", 150, 1),
          },
          {
            ...extraColumnsField("Type", "type", 100, 1),
          },
          {
            ...extraColumnsField("IFSC Code", "ifsc", 100, 1),
          },

          {
            ...extraColumnsField("Assign", "Assign", 100, 1),
            align: "right",
            headerAlign: "right",
            renderCell: (params) => {
              return (
                params?.row?.id !== portfolioData?.bankAccount && (
                  <GKButton
                    variant="text"
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(
                        updatePortfolio({
                          id: portfolioData?.id,
                          portfolioUpdateData: {
                            ...portfolioData,
                            bankAccount: params?.row?.id,
                          },
                        }),
                      );
                    }}
                  >
                    Assign
                  </GKButton>
                )
              );
            },
          },
        ]}
      />
      {openModal && (
        <BankAccountModal
          open={openModal}
          setOpen={setOpenModal}
          allAccounts={data?.data}
          updateData={updateData}
          clientId={portfolioData?.client}
          refetch={refetch}
        />
      )}
    </>
  );
};

export default BankInfoTab;
